// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:50:21

export default {
  "id": "steampunk-tower-builder",
  "slug": "steampunk-tower-builder",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/76cc5bf650e84ce1907858dedb3bbea9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/76cc5bf650e84ce1907858dedb3bbea9/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Steampunk Tower Builder",
      "description": "Build the tallest tower and touch the sky with the steampunk tower builder! Simply tap to release the blocks, making sure to release them at the right time to balance the tower. The tower will rise higher with each correctly placed block. If a block falls, you’ll have to start over. Use the funds you’ve accumulated to build as high as possible and climb the leaderboard!",
      "instructions": "Click when the crane holding the next floor is exactly above the top floor to build the structure evenly without tilting, otherwise it may collapse.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "balance",
        "block",
        "building",
        "physics",
        "tower"
      ]
    },
    "zh-CN": {
      "title": "蒸汽朋克塔楼建造者",
      "description": "建造最高的塔，用蒸汽朋克塔楼建造者触摸天空！只需轻触释放方块，确保在正确的时间释放它们以平衡塔楼。每放置一个正确的方块，塔楼都会越高。如果方块掉落，您将不得不重新开始。使用您累积的资金尽可能建得高，并登上排行榜！",
      "instructions": "当承载下一层的起重机正好位于顶层上方时点击，以均匀建造结构而不会倾斜，否则可能会倒塌。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "平衡",
        "阻挡",
        "建筑",
        "物理",
        "塔"
      ]
    },
    "zh-TW": {
      "title": "蒸汽朋克塔樓建築師",
      "description": "建造最高的塔，用蒸汽機車塔建造者觸碰天際！簡單點擊釋放塊狀物，確保在正確的時間釋放它們以平衡塔身。每當正確放置塊狀物時，塔將會更高。如果塊狀物掉落，您將必須重新開始。使用您累積的資金建造盡可能高的塔並攀登排行榜！",
      "instructions": "當懸吊下一層樓的起重机正確地懸停在頂樓上方時按鈕，以均勻建造結構而不致傾斜，否則可能會倒塌。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "平衡",
        "阻擋",
        "建築",
        "物理",
        "塔"
      ]
    },
    "zh-HK": {
      "title": "蒸汽朋克塔樓建築師",
      "description": "建立最高的塔樓，用蒸汽朋克塔樓建造者觸碰天空！簡單點擊釋放塊狀物，確保在正確的時機釋放，以平衡塔樓。每放置一塊正確的塊狀物，塔樓將會越來越高。如果塊狀物掉落，你將必須重新開始。使用你累積的資金，盡可能地建造並爬升領導板！",
      "instructions": "當懸掛著下一層的起重機正確位於頂樓上方時按鈕，以均勻建築結構而無偏斜，否則可能會倒塌。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "平衡",
        "阻擋",
        "建築",
        "物理",
        "塔樓"
      ]
    },
    "ja": {
      "title": "スティームパンクタワー・ビルダー",
      "description": "最高の塔を建てて、蒸気機関風の塔ビルダーで空に触れよう！ブロックを放つにはタップだけ。ブロックを正しいタイミングで放つことで塔をバランス良く建てることができます。正しく配置されたブロックで塔はどんどん高くなります。ブロックが落ちると、再び始めからやり直すことになります。溜めた資金を使ってできるだけ高い塔を作り、ランキングに昇るようしましょう！",
      "instructions": "次の階を持つクレーンが最上階の上にある時にクリックしてください。そうすることで構造を揺れずに均等に建設できます。それ以外の場合は崩れ落ちる可能性があります。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "バランス",
        "ブロック",
        "建造",
        "物理",
        "タワー"
      ]
    },
    "ko": {
      "title": "스팀파운드 타워 빌더",
      "description": "Steam朋克 타워 빌더로 가장 높은 타워를 지어 하늘을 쳐다보세요! 블록을 떨어뜨리기 위해 단순히 탭하세요. 타워를 균형 잡기 위해 적절한 시간에 블록을 떨어뜨려야 합니다. 올바르게 배치된 블록마다 타워가 높아집니다. 블록이 떨어지면 다시 시작해야 합니다. 모아둔 자금을 사용하여 최대한 높게 지어 리더보드를 치솟아나가세요!",
      "instructions": "다음 층을 들고 있는 크레인이 정상층 위에 정확히 위치했을 때 클릭하세요. 이렇게 하면 건물이 기울지 않고 균형 잡혀 지어집니다. 그렇지 않으면 붕괴할 수 있습니다.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "균형",
        "블록",
        "건물",
        "물리학",
        "타워"
      ]
    },
    "fr": {
      "title": "Constructeur de Tour Steampunk",
      "description": "Construisez la tour la plus haute et touchez le ciel avec le constructeur de tours steampunk ! Tappez simplement pour libérer les blocs, en veillant à les libérer au bon moment pour équilibrer la tour. La tour s'élèvera plus haut avec chaque bloc correctement placé. Si un bloc tombe, vous devrez recommencer. Utilisez les fonds accumulés pour construire le plus haut possible et grimper au classement !",
      "instructions": "Cliquez lorsque la grue portant le prochain étage est exactement au-dessus du dernier étage pour construire la structure uniformément sans pencher, sinon elle pourrait s'effondrer.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "équilibrage",
        "bloc",
        "construction",
        "physique",
        "tour"
      ]
    }
  }
};
